import Grid from '@mui/material/Grid';
import { FormControlLabel, Switch } from '@mui/material';
import React from 'react';

import { ColorProfileMenu } from 'components/ImageViewer/components/ImageViewerToolbar/ColorProfileMenu';

export const QCToolbar = ({
  showOverlay,
  handleOverlayChange,
  handleDisplayFloatingThumbnailChange,
  showFloatingMacroImage,
}) => (
  <Grid container spacing={1} alignItems="center">
    <Grid item>
      <FormControlLabel
        control={
          <Switch
            checked={showOverlay}
            value="showOverlay"
            onChange={handleOverlayChange}
          />
        }
        label="Show Overlays"
      />
    </Grid>
    <Grid item>
      <FormControlLabel
        control={
          <Switch
            checked={showFloatingMacroImage}
            value="displayThumbnail"
            onChange={handleDisplayFloatingThumbnailChange}
          />
        }
        label="Display Thumbnail"
      />
    </Grid>
    <Grid item>
      <ColorProfileMenu />
    </Grid>
  </Grid>
);
